module.exports = __webpack_public_path__ + "img/senalando-izqhn.55cbe780.png";